import { FetchDownloadsSortTypes } from './downloadsTypes';

export const INITIAL_DOWNLOADS_FILTERS = {};
export const INITIAL_DOWNLOADS_PAGE = 1;
export const INITIAL_DOWNLOADS_SORT = [FetchDownloadsSortTypes.CREATED_AT_DESC];
export const INITIAL_DOWNLOADS_LIMIT = 50;
